var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.703,
    height: 18.342,
    viewBox: "0 0 16.703 18.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .inactiveHome {\r\n        fill: #8c8d99;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline_General_Home",
    "data-name": "Outline / General / Home",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-0.648 -0.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "inactiveHome",
    d: "M15.2,18.342H11.035a.751.751,0,0,1-.75-.75V11.381H6.416v6.211a.751.751,0,0,1-.75.75H1.5a.978.978,0,0,1-.971-.832L.346,16.353A28.749,28.749,0,0,1,.473,6.7a2.232,2.232,0,0,1,.654-1.217l4.627-4.44a3.749,3.749,0,0,1,5.192,0l4.627,4.44A2.232,2.232,0,0,1,16.228,6.7a28.749,28.749,0,0,1,.128,9.653l-.181,1.157A.978.978,0,0,1,15.2,18.342ZM5.666,9.881h5.368a.751.751,0,0,1,.75.75v6.212h2.976l.113-.721a27.267,27.267,0,0,0-.121-9.151.752.752,0,0,0-.218-.405L9.908,2.127a2.249,2.249,0,0,0-3.115,0L2.166,6.565a.752.752,0,0,0-.218.405,27.267,27.267,0,0,0-.121,9.151l.113.721H4.917V10.631A.751.751,0,0,1,5.666,9.881Z",
    transform: "translate(0.649 0.408)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveHome);
export default __webpack_public_path__ + "static/media/inactive-home.a6422ce56d0cd56bca81ecd1afc032f5.svg";
export { ForwardRef as ReactComponent };